import { firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { CompanyProfileServiceProxy } from '@shared/service-proxies/service-proxies';
import { AbpSessionService } from 'abp-ng2-module';

@Injectable({
    providedIn: 'root'
  })
export class UsersDateFormatService {


    constructor(private _companyProfile: CompanyProfileServiceProxy,
                private _abpSessionService: AbpSessionService) {}           

  findUsersDateFormat(formatType: number): string {
    let dateType = Number(formatType);
    switch (dateType) {
        case 1: {
            return 'dd/MM/yyyy';
        }
        case 2: {
            return 'MM/dd/yyyy';
        }
        case 3: {
            return 'yyyy/dd/MM';
        }
        default: {
            return 'dd/MM/yyyy';
        }
    }
  }

  async getCompanyDateTypeInfo(): Promise<string> {
      if (!AppConsts?.companyDetails) {
          const tenantId = this._abpSessionService.tenantId ? this._abpSessionService.tenantId : undefined;
          AppConsts.companyDetails = await firstValueFrom(this._companyProfile.getCompanyProfileDetailsForEditView(tenantId));
      }

      if (!AppConsts.dateFormatId) {
          AppConsts.dateFormatId = AppConsts.companyDetails?.dateFormat;
      }

      return this.returnDateType(AppConsts.companyDetails);
    }
  returnDateType(x): string {
    let dateType = x.dateFormat; 
    switch (dateType) {
      case 1: {
        return 'dd/MM/yyyy';
      }
      case 2: {
        return 'MM/dd/yyyy';
      }
      case 3: {
        return 'yyyy/MM/dd';
      }
      default: {
        return 'dd/MM/yyyy';
      }
    }
  }
}
